<template>
	<div class="info">
		<div class="tops">
			<div class="lunbo">
				<el-carousel>
					<el-carousel-item v-for="item in list.banner" :key="item" @click='detail2(item.id)'>
						<img style="width: 468px;height: 300px;" :src="item.img" alt="">
						<p class="text">{{item.title}}</p>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="infoOneList">
				<ul class="top">
					<li v-for="(item,index) in list.article1" @click="choose_1(index)" :class="{choose:infoOneChoose1 == index}">{{item.attr_name}}</li>
				</ul>
				<ul class="bottom">
					<li @click="detail(itemChild.id)" v-for="itemChild in infoOneList1">{{itemChild.title}}</li>
				</ul>
			</div>
		</div>
		<div class="Two">
			<div class="infoTwoList">
				<ul class="top">
					<li v-for="(item,index) in list.article2" @click="choose_2(index)" :class="{choose:infoOneChoose2 == index}">{{item.attr_name}}</li>
				</ul>
				<ul class="bottom">
					<li @click="detail(itemChild.id)" v-for="itemChild in infoOneList2">{{itemChild.title}}</li>
				</ul>
			</div>
			<div class="infoThreeList">
				<ul class="top">
					<li v-for="(item,index) in list.article3" class="choose">{{item.attr_name}}</li>
					<li class="more">查看更多</li>
				</ul>
				<ul class="bottom">
					<li @click="detail(itemChild.id)" v-for="itemChild in infoOneList3">{{itemChild.title}}</li>
				</ul>
			</div>
		</div>
		<div class="Three">
			<ul>
				<li>
					<div class="box" @click="lists(2)">
						医药信息<span>咨询</span>服务
					</div>
				</li>
				<li>
					<div class="box" @click="lists(3)">
						医药新闻<span>咨询</span>服务
					</div>
				</li>
				<li>
					<div class="box" @click="lists(4)">
						药品价格<span>咨询</span>服务
					</div>
				</li>
				<li>
					<div class="box" @click="lists(5)">
						医药人才<span>咨询</span>服务
					</div>
				</li>
			</ul>
		</div>
		<div class="Four">
			<div class="infoFourList">
				<ul class="top">
					<li v-for="(item,index) in list.article4" class="choose">{{item.attr_name}}</li>
				</ul>
				<ul class="bottom">
					<li @click="detail(itemChild.id)" v-for="itemChild in infoOneList4"><span>{{index}}</span>{{itemChild.title}}</li>
				</ul>
			</div>
			<div class="infoFiveList">
				<ul class="top">
					<li class="choose" v-for="(item,index) in list.article5">{{item.attr_name}}</li>
				</ul>
				<ul class="bottom">
					<li @click="detail(itemChild.id)" v-for="itemChild in infoOneList5"><span>{{index}}</span>{{itemChild.title}}</li>
				</ul>
			</div>
			<img src="../assets/ceshi3.png" alt="">
		</div>
		<div class="Five">
			<div class="infoSixList">
				<div class="one" v-for="item in list.article5" @click="detail((item.article)[0].id)">
					<img class="img" :src="(item.article)[0].image" alt="">
					<div class="rg">
						<h3>{{(item.article)[0].title}}</h3>
						<p class="dao">导读：{{(item.article)[0].summary}}</p>
						<div>
							<img class="icon" src="../assets/home_2.png" alt="">
							<p>新闻</p>
						</div>
					</div>
				</div>
				<div class="one" v-for="item in list.article5" @click="detail((item.article)[1].id)">
					<img class="img" :src="(item.article)[1].image" alt="">
					<div class="rg">
						<h3>{{(item.article)[1].title}}</h3>
						<p class="dao">导读：{{(item.article)[1].summary}}</p>
						<div>
							<img class="icon" src="../assets/home_2.png" alt="">
							<p>新闻</p>
						</div>
					</div>
				</div>
			</div>
			<div class="infoSevenList">
				<ul class="top">
					<li v-for="item in list.article6" :class="{choose:infoOneChoose == item.id}">{{item.attr_name}}</li>
				</ul>
				<ul class="bottom">
					<li @click="detail(itemChild.id)" v-for="itemChild in infoOneList6">{{itemChild.title}}</li>
				</ul>
			</div>

		</div>
		<div class="Two">
			<div class="infoTwoList">
				<ul class="top">
					<li v-for="item in list.article7" :class="{choose:infoOneChoose == item.id}">{{item.attr_name}}</li>
				</ul>
				<ul class="bottom">
					<li @click="detail(itemChild.id)" v-for="itemChild in infoOneList7">{{itemChild.title}}</li>
				</ul>
			</div>
			<div class="infoThreeList">
				<ul class="top">
					<li v-for="item in list.article8" :class="{choose:infoOneChoose == item.id}">{{item.attr_name}}</li>
					<li class="more">查看更多</li>
				</ul>
				<ul class="bottom">
					<li @click="detail(itemChild.id)" v-for="itemChild in infoOneList8">{{itemChild.title}}</li>
				</ul>
			</div>
		</div>
		<div class="Six">
			<div class="top">
				<div class="left">
					<div class="one" v-for="item in infoOneList8_1" @click="detail(item.id)">
						<h3>{{item.title}}</h3>
						<div class="share">
							<div class="icon">
								<img src="../assets/home_2.png" alt="">
								<p>新闻</p>
							</div>
							<p class="time">2021-12-06</p>
						</div>
					</div>
				</div>
				<div class="right" v-for="item in infoOneList8_2" @click="detail(item.id)">
					<img class="img" :src="item.image" alt="">
					<div class="rg">
						<h3>{{item.title}}</h3>
						<p class="dao">导读：{{item.summary}}</p>
						<div class="share">
							<div class="icon">
								<img class="icon" src="../assets/home_2.png" alt="">
								<p>新闻</p>
							</div>
							<p class="time">2021-12-06</p>
						</div>
					</div>
				</div>
			</div>
			<div class="bottom">
				<div class="right right2" v-for="item in infoOneList8_3" @click="detail(item.id)">
					<img class="img" :src="item.image" alt="">
					<div class="rg">
						<h3>{{item.title}}</h3>
						<p class="dao">导读：{{item.summary}}</p>
						<div class="share">
							<div class="icon">
								<img class="icon" src="../assets/home_2.png" alt="">
								<p>新闻</p>
							</div>
							<p class="time">2021-12-06</p>
						</div>
					</div>
				</div>
				<div class="left">
					<div class="one" v-for="item in infoOneList8_4" @click="detail(item.id)">
						<h3>{{item.title}}</h3>
						<div class="share">
							<div class="icon">
								<img src="../assets/home_2.png" alt="">
								<p>新闻</p>
							</div>
							<p class="time">2021-12-06</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Seven">
			<div v-for="item in infoOneList9" class="one" @click="detail(item.id)">
				<img class="img" :src="item.image" alt="">
				<div class="rg">
					<h3>{{item.title}}</h3>
					<p class="dao">导读：{{item.summary}}</p>
					<div class="share">
						<div class="icon">
							<img class="icon" src="../assets/home_2.png" alt="">
							<p>新闻</p>
						</div>
						<p class="time">{{item.addtime}}</p>
					</div>
				</div>

			</div>
			<!-- <button>加载更多</button> -->
		</div>
	</div>
</template>

<script>
	// 引入axios
	import axios from 'axios';
	// 引入端口配置文件
	import API_LIST from '@/list.config.js';
	import qs from 'qs'

	export default {
		name: "HelloWorld",
		props: {

		},
		data() {
			return {
				list: '',
				infoOneList1: [],
				infoOneList2: [],
				infoOneList3: [],
				infoOneList4: [],
				infoOneList5: [],
				infoOneList6: [],
				infoOneList7: [],
				infoOneList8: [],
				infoOneList9: [],
				infoOneChoose1: 0,
				infoOneChoose2: 0,
				infoOneChoose3: 0,
				infoOneChoose4: 0,
				infoOneChoose5: 0,
				infoOneChoose6: 0,
			}

		},
		watch: {


		},
		beforeCreate() {

		},
		created() {
			const that = this;
			axios.post(API_LIST.index, {}, {
					headers: {
						// 'Content-Type': 'application/x-www-form-urlencoded'
						'Content-Type': 'application/json'
					} //加上这个x
				})
				.then(_d => {
					console.log(_d.data)
					if (_d.data.status == 200) {
						// console.log(_d)
						that.list = _d.data.list
						that.infoOneList1 = (_d.data.list.article1)[0].article
						that.infoOneList2 = (_d.data.list.article2)[0].article
						that.infoOneList3 = (_d.data.list.article3)[0].article
						that.infoOneList4 = (_d.data.list.article4)[0].article
						that.infoOneList5 = (_d.data.list.article5)[0].article
						that.infoOneList6 = (_d.data.list.article6)[0].article
						that.infoOneList7 = (_d.data.list.article7)[0].article
						that.infoOneList8 = (_d.data.list.article8)[0].article
						that.infoOneList8_1 = that.infoOneList8.slice(0, 4)
						that.infoOneList8_2 = that.infoOneList8.slice(4, 5)
						that.infoOneList8_3 = that.infoOneList8.slice(5, 6)
						that.infoOneList8_4 = that.infoOneList8.slice(6, 10)


						that.infoOneList9 = (_d.data.list.article9)[0].article
						console.log(that.infoOneList4)
					} else if (_d.data.status == 409) {

					}


				})
				.catch(function(error) {
					console.log(error);
				});
		},

		mounted() {

		},
		methods: {
			// 选择1
			choose_1(_id) {
				const that = this;
				that.infoOneChoose1 = _id;
				that.infoOneList1 = (that.list.article1)[_id].article
			},
			// 选择2
			choose_2(_id) {
				const that = this;
				that.infoOneChoose2 = _id;
				that.infoOneList2 = (that.list.article2)[_id].article
			},
			// 点击四个块
			lists(_id){
				console.log(this)
				this.$router.push({
					path:'/List',
					query:{
						id:_id
					}
				})
			},
			detail(_id) {
				this.$router.push({
					path: '/Detail',
					query: {
						id: _id,
					}
				})
			},
			// 详情
			detail2(_id) {
				this.$router.push({
					path: '/Detail',
					query: {
						id: _id,
						sort:true,
					}
				})
			}
		}
	};
</script>

<style scoped="scoped" lang="scss">
	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
		text-align: center;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}

	.info {
		width: 850px;

	}

	.tops {
		display: flex;
		flex-direction: row;
		justify-content: space-between;

		.lunbo {
			width: 480px;
			height: 320px;

			.text {
				position: absolute;
				bottom: 0;
				background-color: #313131;
				font-size: 16px;
				color: #fff;
				width: 100%;
				padding: 5px 0;
			}
		}

		.infoOneList {
			margin: 0 0 0 10px;
			width: 380px;
			display: flex;
			flex-direction: column;

			.top {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				border-bottom: 2px solid #CDCDCD;
				padding: 0 5px 5px;

				li {
					font-size: 16px;
					color: #000;
					font-family: MicrosoftYaHei;
				}

				li:hover {
					cursor: pointer;
				}
			}

			.bottom {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;

				li {
					margin: 3px 0;
					font-size: 12px;
					text-align: left;
					padding: 0 0 0 10px;
					box-sizing: border-box;
				}

				li:hover {
					cursor: pointer;
					color: #39A49B;
				}
			}

		}
	}

	.Two {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 100%;
		margin: 10px 0 0 0;

		.infoTwoList {
			width: 470px;

			.top {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				border-bottom: 2px solid #CDCDCD;
				padding: 0 5px 5px;

				li {
					font-size: 16px;
					color: #000;
					font-family: MicrosoftYaHei;
				}

				li:hover {
					cursor: pointer;
				}

			}


			.bottom {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				height: 240px;

				li {
					margin: 5px 0;
					font-size: 12px;
					text-align: left;
					padding: 0 0 0 10px;
					box-sizing: border-box;
					position: relative;
				}

				li:after {
					content: '';
					position: absolute;
					left: 0px;
					top: 0;
					bottom: 0;
					margin: auto;
					width: 0;
					height: 0;
					border-top: 5px solid transparent;
					border-bottom: 5px solid transparent;
					border-left: 5px solid #000;
				}

				li:hover {
					cursor: pointer;
					color: #39A49B;
				}
			}

		}

		.infoThreeList {
			width: 370px;

			.top {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				border-bottom: 2px solid #CDCDCD;
				padding: 0 5px 5px;

				li {
					font-size: 16px;
					color: #000;
					font-family: MicrosoftYaHei;
				}
			}

			.bottom {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;

				li {
					margin: 5px 0;
					font-size: 12px;
					text-align: left;
					padding: 0 0 0 30px;
					box-sizing: border-box;
					position: relative;
				}

				li:after {
					content: '';
					position: absolute;
					left: 10px;
					top: 0;
					bottom: 0;
					margin: auto;
					width: 0;
					height: 0;
					border-top: 5px solid transparent;
					border-bottom: 5px solid transparent;
					border-left: 5px solid #000;
				}

				li:hover {
					cursor: pointer;
					color: #39A49B;
				}
			}
		}

	}

	.more {
		font-size: 12px !important;
		color: #39A49B !important;
		position: relative;
		padding: 0 10px 0 0;
	}

	.more::after {
		content: '';
		position: absolute;
		right: 0;
		top: -3px;
		bottom: 0;
		margin: auto;
		width: 5px;
		height: 5px;
		border-right: 1px solid #39A49B;
		border-bottom: 1px solid #39A49B;
		transform: rotate(-45deg);
	}

	.Three {
		width: 100%;
		margin: 30px 0 0 0;

		ul {
			display: flex;
			flex-direction: row;
			justify-content: space-between;

			li {
				.box {
					width: 184px;
					height: 50px;
					background-color: #33CCCC;
					// box-sizing: border-box;
					border: 10px solid #39A49B;
					text-align: center;
					line-height: 50px;
					font-size: 17px;
					font-weight: 700;
					color: #fff;
					position: relative;
					span{
						font-size: 20px;
						font-family: STXinwei;
						margin: 0 2px;
					}
				}
				.box:hover{
					cursor: pointer;
				}

				.box::before {
					content: "";
					position: absolute;
					left: 10px;
					top: 10px;
					// margin: auto;
					width: 0;
					height: 0;
					border-top: 5px solid transparent;
					border-bottom: 5px solid transparent;
					border-left: 5px solid #39A49B;
				}
				.box::after {
					content: "";
					position: absolute;
					right: 10px;
					bottom: 10px;
					// margin: auto;
					width: 0;
					height: 0;
					border-top: 5px solid transparent;
					border-bottom: 5px solid transparent;
					border-left: 5px solid #39A49B;
				}
			}
		}
	}

	.Four {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
		width: 100%;
		margin: 10px 0 0 0;

		.infoFourList {
			width: 220px;
			background-color: #fff;

			.top {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				border-bottom: 2px solid #CDCDCD;
				padding: 0 5px 5px;

				li {
					font-size: 16px;
					color: #000;
					font-family: MicrosoftYaHei;
				}

			}


			.bottom {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				height: 260px;

				li {
					margin: 5px 0;
					font-size: 12px;
					text-align: left;
					padding: 0 0 0 10px;
					box-sizing: border-box;
					position: relative;
					white-space: nowrap;
					/*设置内容不换行*/
					text-overflow: ellipsis;
					/*设置文字超出文本框的内容显示成...*/
					overflow: hidden;
				}


				li:hover {
					cursor: pointer;
					color: #39A49B;
				}
			}

		}

		.infoFiveList {
			width: 260px;

			.top {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				border-bottom: 2px solid #CDCDCD;
				padding: 0 5px 5px;

				li {
					font-size: 16px;
					color: #000;
					font-family: MicrosoftYaHei;
				}
			}

			.bottom {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				height: 260px;

				li {
					margin: 5px 0;
					font-size: 12px;
					text-align: left;
					padding: 0 0 0 30px;
					box-sizing: border-box;
					position: relative;
					white-space: nowrap;
					/*设置内容不换行*/
					text-overflow: ellipsis;
					/*设置文字超出文本框的内容显示成...*/
					overflow: hidden;
				}


				li:hover {
					cursor: pointer;
					color: #39A49B;
				}
			}
		}

		img {
			width: 300px;
			height: 227px;
		}
	}

	.Five {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 100%;
		margin: 10px 0 0 0;

		.infoSixList {
			width: 480px;
			display: flex;
			flex-direction: column;
			margin: 30px 0;

			.one {
				display: flex;
				flex-direction: row;
				margin-bottom: 10px;

				.img {
					width: 212px;
					height: 120px;
				}

				.rg {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: flex-start;
					text-align: left;
					margin-left: 10px;
					width: 230px;

					h3 {
						font-size: 14px;
						color: #000;
					}

					.dao {
						font-size: 12px;
						font-family: MicrosoftYaHei;
						color: #999999;
						margin: 20px 0 0 0;
						width: 230px;
						height: 50px;
						overflow: hidden;
					}

					div {
						display: flex;
						flex-direction: row;

						img {
							width: 14px;
							height: 13px;
						}

						p {
							font-size: 12px;
							font-family: MicrosoftYaHei;
							color: #999999;
							margin-left: 5px;
						}
					}

				}
			}
		}

		.infoSevenList {
			width: 380px;

			.top {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				border-bottom: 2px solid #CDCDCD;
				padding: 0 5px 5px;

				li {
					font-size: 16px;
					color: #000;
					font-family: MicrosoftYaHei;
				}
			}

			.bottom {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;

				li {
					margin: 5px 0;
					font-size: 12px;
					text-align: left;
					padding: 0 0 0 30px;
					box-sizing: border-box;
					position: relative;
				}

				li:after {
					content: '';
					position: absolute;
					left: 10px;
					top: 0;
					bottom: 0;
					margin: auto;
					width: 3px;
					height: 3px;
					border-radius: 50%;
					background-color: #000;
				}

				li:hover {
					cursor: pointer;
					color: #39A49B;
				}
			}
		}

	}

	.Six {
		display: flex;
		flex-direction: column;
		margin: 20px 0;

		.top,
		.bottom {
			display: flex;
			flex-direction: row;
			margin: 0px 0 0 0;
		}

		.left {
			width: 380px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			flex-wrap: wrap;

			.one {
				width: 183px;
				height: 66px;
				background-color: #fff;
				text-align: left;
				box-sizing: border-box;
				padding: 5px;
				margin: 0 0 15px 0;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				h3 {
					font-size: 12px;
					font-family: MicrosoftYaHei;
					color: #333333;
					height: 30px;
					overflow: hidden;
				}

				.share {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;

					.icon {
						display: flex;
						flex-direction: row;
						align-items: center;

						img {
							width: 11px;
							height: 10px;
							margin-right: 5px;
						}

						p {
							font-size: 10px;
							font-family: MicrosoftYaHei;
							color: #999999;
						}
					}

					.time {
						font-size: 10px;
						font-family: MicrosoftYaHei;
						color: #999999;
					}
				}

			}
		}

		.right {
			width: 440px;
			height: 147px;
			display: flex;
			flex-direction: row;
			background-color: #fff;
			box-sizing: border-box;
			padding: 10px;
			margin: 0 0 0 10px;

			.img {
				width: 212px;
				height: 120px;
			}

			.rg {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: flex-start;
				text-align: left;
				margin-left: 10px;

				h3 {
					font-size: 14px;
					color: #000;
				}

				.dao {
					font-size: 12px;
					font-family: MicrosoftYaHei;
					color: #999999;
					margin: 20px 0 0 0;
					height: 50px;
					overflow: hidden;
				}

				.share {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					width: 100%;

					.icon {
						display: flex;
						flex-direction: row;
						align-items: center;

						img {
							width: 11px;
							height: 10px;
							margin-right: 5px;
						}

						p {
							font-size: 10px;
							font-family: MicrosoftYaHei;
							color: #999999;
						}
					}

					.time {
						font-size: 10px;
						font-family: MicrosoftYaHei;
						color: #999999;
					}
				}

			}
		}

		.right2 {
			margin: 0 10px 0 0;
		}

	}

	.Seven {
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;
		width: 100%;

		.one {
			display: flex;
			flex-direction: row;
			margin: 0 0 50px 0;
		}

		.img {
			width: 166px;
			height: 109px;
		}

		.rg {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: flex-start;
			text-align: left;
			margin-left: 10px;
			flex: 1;

			h3 {
				font-size: 14px;
				color: #000;
			}

			.dao {
				font-size: 12px;
				font-family: MicrosoftYaHei;
				color: #999999;
				margin: 20px 0 0 0;
			}

			.share {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				width: 300px;

				.icon {
					display: flex;
					flex-direction: row;
					align-items: center;

					img {
						width: 11px;
						height: 10px;
						margin-right: 5px;
					}

					p {
						font-size: 10px;
						font-family: MicrosoftYaHei;
						color: #999999;
					}
				}

				.time {
					font-size: 10px;
					font-family: MicrosoftYaHei;
					color: #999999;
				}
			}

		}

		button {
			width: 155px;
			height: 40px;
			background: #39A49B;
			margin: 0 auto;
			color: #fff;
			font-size: 14px;
		}
	}



















	.el-carousel {
		.el-carousel__item:nth-child(2n) {
			background-color: #99a9bf;
		}

		.el-carousel__item:nth-child(2n+1) {
			background-color: #d3dce6;
		}

		::v-deep .el-carousel__indicators {
			// 指示器
			left: unset;
			transform: unset;
			right: 2%;
			bottom: 30px;
		}

		::v-deep .el-carousel__button {
			// 指示器按钮
			width: 10px;
			height: 10px;
			border: none;
			border-radius: 50%;
			background-color: rgba(0, 0, 0, 0.2);
			display: flex;
			flex-direction: row;
			align-items: center;
		}

		::v-deep .is-active .el-carousel__button {
			// 指示器激活按钮
			background: #39A49B;
			width: 11px;
			height: 11px;
		}
	}

	.choose {
		color: #39A49B !important;
		position: relative;
	}

	.choose::after {
		content: '';
		width: 90%;
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
		bottom: -6px;
		height: 2px;
		background-color: #39A49B;
	}
</style>
